module.exports = __webpack_public_path__ + "static/media/DesignOptimized.77cd7e08.jp2";